<template>
  <v-app>
    <v-app-bar
      app
      :color="offsetTop > 0 ? 'black' : 'transparent'"
      elevate-on-scroll
      height="120"
      v-if="
        !$router.currentRoute.path.includes('modelo-educativo') &&
        !$router.currentRoute.path.includes('modelo-educativo') &&
        !$router.currentRoute.path.includes('modelo-educativo')
      "
    >
      <v-toolbar-title class="headline text-uppercase">
        <router-link
          to="/"
          v-if="
            $router.currentRoute.path.includes('diplomado') &&
            $vuetify.breakpoint.mdAndUp
          "
        >
          <v-img
            v-if="offsetTop > 0"
            :height="$vuetify.breakpoint.mdAndUp ? '150' : '100'"
            :width="$vuetify.breakpoint.mdAndUp ? '300' : '150'"
            contain
            :src="`${publicPath}images/iconos/LOGO-UVA.png`"
          ></v-img>
          <v-img
            v-else
            :height="$vuetify.breakpoint.mdAndUp ? '80' : '20'"
            :width="$vuetify.breakpoint.mdAndUp ? '230' : '80'"
            contain
            :src="`${publicPath}images/Logo-azul.png`"
            :class="$vuetify.breakpoint.mdAndUp ? 'ml-8' : ''"
          ></v-img>
        </router-link>
        <router-link to="/" v-else>
          <v-img
            :height="$vuetify.breakpoint.mdAndUp ? '150' : '100'"
            :width="$vuetify.breakpoint.mdAndUp ? '300' : '150'"
            contain
            :src="`${publicPath}images/iconos/LOGO-UVA.png`"
          ></v-img>
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        fab
        light
        color="white"
        class="hidden-md-and-up mr-3"
        @click="drawer = !drawer"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>
      <v-menu offset-y class="hidden-sm-and-down">
        <template v-slot:activator="{ on }">
          <v-btn
            class="hidden-sm-and-down mr-2"
            color="white"
            outlined
            rounded
            v-on="on"
            >Licenciaturas</v-btn
          >
        </template>
        <v-list>
          <v-list-item v-for="(item, index) in offer" :key="index" class="pa-0">
            <router-link
              class="py-2 px-5 black--text body-1"
              style="text-decoration: none; width: 100%"
              :to="item.link"
              >{{ item.name }}</router-link
            >
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu offset-y class="hidden-sm-and-down">
        <template v-slot:activator="{ on }">
          <v-btn
            class="hidden-sm-and-down mr-2"
            color="white"
            outlined
            rounded
            v-on="on"
            >Diplomados</v-btn
          >
        </template>
        <v-list>
          <v-list-item v-for="(item, index) in dips" :key="index" class="pa-0">
            <router-link
              class="py-2 px-5 black--text body-1"
              style="text-decoration: none; width: 100%"
              :to="item.link"
              >{{ item.name }}</router-link
            >
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu offset-y class="hidden-sm-and-down">
        <template v-slot:activator="{ on }">
          <v-btn
            class="hidden-sm-and-down mr-2"
            color="white"
            outlined
            rounded
            v-on="on"
            >Maestrías</v-btn
          >
        </template>
        <v-list>
          <v-list-item v-for="(item, index) in maest" :key="index" class="pa-0">
            <router-link
              class="py-2 px-5 black--text body-1"
              style="text-decoration: none; width: 100%"
              :to="item.link"
              >{{ item.name }}</router-link
            >
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu offset-y class="hidden-sm-and-down">
        <template v-slot:activator="{ on }">
          <v-btn
            class="hidden-sm-and-down mr-2"
            color="white"
            outlined
            rounded
            v-on="on"
            >Sistema Vizcaya</v-btn
          >
        </template>
        <v-list>
          <v-list-item class="pa-0">
            <router-link
              class="py-2 px-5 black--text body-1"
              style="text-decoration: none; width: 100%"
              to="/sistema"
              >Nuestro sistema
              <v-icon color="white">mdi-menu-down</v-icon>
            </router-link>
          </v-list-item>
          <v-list-item class="pa-0">
            <a
              href="Reglamento_UVAL.pdf"
              target="_blank"
              class="py-2 px-5 black--text body-1"
              style="text-decoration: none"
            >
              Reglamento institucional 2021</a
            >
          </v-list-item>
        </v-list>
      </v-menu>
      <router-link style="text-decoration: none" :to="link_diav">
        <v-btn class="hidden-sm-and-down mr-2" color="white" outlined rounded
          >Quejas y sugerencias</v-btn
        >
      </router-link>
      <v-btn
        class="hidden-sm-and-down mr-2"
        color="white"
        outlined
        rounded
        @click="dialog = !dialog"
      >
        <span class="mr-2">Accede a clases</span>
      </v-btn>
    </v-app-bar>
    <v-dialog v-model="dialog" fullscreen>
      <v-snackbar
        v-model="snackbar"
        :multi-line="false"
        :right="true"
        :top="true"
      >
        {{ text }}
        <v-btn color="red" text @click="snackbar = false">Cerrar</v-btn>
      </v-snackbar>
      <v-card color="white" class tile>
        <v-layout
          :row="$vuetify.breakpoint.mdAndUp"
          class="mx-0"
          :column="$vuetify.breakpoint.smAndDown"
        >
          <v-flex
            xs12
            sm12
            md6
            lg7
            class="bg-flex"
            :style="{
              backgroundImage:
                'url(' + `${publicPath}images/imagenes/accede-clases.jpg` + ')',
            }"
            v-if="$vuetify.breakpoint.mdAndUp"
          >
            <v-img
              :height="$vuetify.breakpoint.mdAndUp ? '200' : '100'"
              :width="$vuetify.breakpoint.mdAndUp ? '400' : '150'"
              contain
              :src="`${publicPath}images/iconos/LOGO-UVA.png`"
            ></v-img>
          </v-flex>
          <v-flex
            xs12
            sm12
            md6
            lg5
            :class="[$vuetify.breakpoint.mdAndUp ? 'pa-12' : 'pa-2']"
            class="justify-center align-center d-flex flex-column"
          >
            <v-card-title>
              <h1
                class="word-break text-uppercase font-weight-bold mb-4"
                :class="[
                  $vuetify.breakpoint.mdAndUp ? 'display-1' : 'headline',
                ]"
              >
                Acceder a clases
              </h1>
            </v-card-title>
            <v-card-title
              :class="[$vuetify.breakpoint.mdAndUp ? 'mb-12' : 'mb-2']"
            >
              <h3 class="title word-break">
                Bienvenido(a) al portal de UVA en Línea
              </h3>
            </v-card-title>
            <v-form
              method="post"
              action="https://web6.servoescolar.mx/login.aspx"
              id="nativeForm"
            >
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      label="SCHOOL"
                      v-model="dominio"
                      v-show="alwaysShow"
                      name="Dominio"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      label="USUARIO"
                      v-model="information.email"
                      type="email"
                      id="email"
                      name="Usuario"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      label="CONTRASEÑA"
                      v-model="information.password"
                      type="password"
                      id="password"
                      name="Contrasena"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <p class="body-1">¿Aún no eres Gente Vizcaya?</p>
                <router-link
                  to="/inscripciones"
                  style="text-decoration: none; padding-bottom: 10px"
                >
                  <v-btn
                    @click="dialog = !dialog"
                    text
                    color="primary"
                    class="font-italic pl-0"
                    >Inscríbete</v-btn
                  >
                </router-link>
              </v-card-text>
              <v-card-actions class="w-100">
                <v-layout
                  :row="$vuetify.breakpoint.mdAndUp"
                  :column="$vuetify.breakpoint.smAndDown"
                  :reverse="$vuetify.breakpoint.smAndDown"
                  justify-end
                >
                  <v-btn
                    rounded
                    large
                    text
                    class="px-5"
                    @click="dialog = !dialog"
                    >Regresar</v-btn
                  >
                  <v-btn
                    rounded
                    large
                    color="primary"
                    class="px-10 mb-5"
                    @click="loginRedirect()"
                    >Acceder</v-btn
                  >
                </v-layout>
              </v-card-actions>
            </v-form>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-navigation-drawer
      v-model="drawer"
      app
      v-if="$vuetify.breakpoint.smAndDown"
    >
      <v-list dense>
        <v-list-item v-for="item in offer" :key="item.name" link>
          <router-link
            class="py-2 px-5 black--text body-1"
            style="text-decoration: none; width: 100%"
            :to="item.link"
            >LIC. {{ item.name }}</router-link
          >
        </v-list-item>
        <v-list-item v-for="item in dips" :key="item.name" link>
          <router-link
            class="py-2 px-5 black--text body-1"
            style="text-decoration: none; width: 100%"
            :to="item.link"
            >DIP. {{ item.name }}</router-link
          >
        </v-list-item>
        <v-list-item link>
          <router-link
            class="py-2 px-5 black--text body-1"
            style="text-decoration: none; width: 100%"
            to="/maestria-en-educacion"
            >MAESTRIA EN EDUCACION</router-link
          >
        </v-list-item>        
        <v-list-item link>
          <router-link
            class="py-2 px-5 black--text body-1"
            style="text-decoration: none; width: 100%"
            to="/sistema"
            >SISTEMA VIZCAYA</router-link
          >
        </v-list-item>
        <v-list-item link>
          <a
            href="Reglamento_UVAL.pdf"
            target="_blank"
            class="py-2 px-5 black--text body-1"
            style="text-decoration: none"
          >
            REGLAMENTO INSTITUCIONAL 2021</a
          >
        </v-list-item>
        <v-list-item link>
          <router-link
            class="py-2 px-5 black--text body-1"
            style="text-decoration: none; width: 100%"
            to="/quejas-y-sugerencias"
            >QUEJAS Y SUGERENCIAS</router-link
          >
        </v-list-item>
        <v-list-item link @click="dialog = !dialog" class="pl-9"
          >ACCEDE A TUS CLASES</v-list-item
        >
      </v-list>
    </v-navigation-drawer>
    <router-view />
    <v-btn
      v-if="
        $vuetify.breakpoint.mdAndUp &&
        !$router.currentRoute.path.includes('modelo-educativo')
      "
      fab
      style="
        z-index: 6;
        cursor: pointer;
        background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%,#285aeb 90%);
        position: fixed;
        bottom: 240px;
        right: 20px;
        height: 60px;
        width: 60px;
      "
      href="https://www.instagram.com/uva_enlinea/"
      target="_blank"
    >
      <v-icon color="white">mdi-instagram</v-icon>
    </v-btn>
    <v-btn
      id="social_media_facebook"
      v-if="
        $vuetify.breakpoint.mdAndUp &&
        !$router.currentRoute.path.includes('modelo-educativo')
      "
      fab
      color="#3b5998"
      style="
        z-index: 6;
        cursor: pointer;
        position: fixed;
        bottom: 170px;
        right: 20px;
        height: 60px;
        width: 60px;
      "
      href="https://www.facebook.com/UVAenlinea"
      target="_blank"
    >
      <v-icon color="white">mdi-facebook</v-icon>
    </v-btn>
    <v-btn
      id="social_media_facebook"
      v-if="
        $vuetify.breakpoint.mdAndUp &&
        !$router.currentRoute.path.includes('modelo-educativo')
      "
      fab
      color="#D6483C"
      style="
        z-index: 6;
        cursor: pointer;
        position: fixed;
        bottom: 100px;
        right: 20px;
        height: 60px;
        width: 60px;
      "
      href="mailto:informes@uvaenlinea.com"
      target="_blank"
    >
      <v-icon color="white">mdi mdi-email</v-icon>
    </v-btn>
    <!--RESPONSIVE-->
    <v-speed-dial
      v-model="fab"
      :top="top"
      :bottom="bottom"
      :right="right"
      :left="left"
      :direction="direction"
      :open-on-hover="hover"
      :transition="transition"
      v-if="
        $vuetify.breakpoint.smAndDown &&
        !$router.currentRoute.path.includes('modelo-educativo')
      "
      style="
        z-index: 6;
        cursor: pointer;
        position: fixed;
        bottom: 90px;
        right: 20px;
        height: 60px;
        width: 60px;
      "
    >
      <template v-slot:activator>
        <v-btn v-model="fab" color="blue darken-2" dark fab>
          <v-icon v-if="fab">mdi-close</v-icon>
          <v-icon v-else>mdi-share-variant</v-icon>
        </v-btn>
      </template>
      <v-btn
        fab
        dark
        color="red"
        target="_blank"
        href="mailto:informes@uvaenlinea.com"
      >
        <v-icon>mdi-email</v-icon>
      </v-btn>
      <v-btn
        fab
        dark
        target="_blank"
        id="social_media_facebook_movil"
        href="https://www.facebook.com/UVAenlinea"
        color="#3b5998"
      >
        <v-icon>mdi-facebook</v-icon>
      </v-btn>
      <v-btn
        fab
        dark
        target="_blank"
        href=""
        color=""
        style="
          background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285aeb 90%);
        "
      >
        <v-icon>mdi-instagram</v-icon>
      </v-btn>
    </v-speed-dial>
    <v-btn
      @click="$router.push('/inscripciones')"
      v-if="
        !$router.currentRoute.path.toLowerCase().includes('/inscripciones') &&
        !$router.currentRoute.path.toLowerCase().includes('/logistica') &&
        !$router.currentRoute.path.includes('modelo-educativo')
      "
      fab
      color="primary"
      class="floating-button uvaldo-btn"
    >
      <v-img max-height="30" max-width="30" src="/uvaldito.png"></v-img>
    </v-btn>
    <v-footer
      color="grey lighten-2"
      class="font-weight-medium"
      v-if="
        !$router.currentRoute.path.includes('modelo-educativo') &&
        $router.currentRoute.path != '/aniversario-vizcaya' &&
        !$router.currentRoute.path.includes('gracias') 
      "
    >
      <v-col class="justify-center align-center d-flex flex-column" cols="12">
        <v-img
          class="p-1pcnt"
          height="auto"
          width="250px"
          contain
          :src="`${publicPath}images/Logo-azul.png`"
        ></v-img>
        <a
          target="_blank"
          @click="toAviso()"
          class="v-btn v-btn--flat v-btn--text theme--light v-size--x-small"
          >Aviso de privacidad</a
        >
        <router-link style="text-decoration: none" to="/faq">
          <v-btn class="ma-2" rounded outlined color="primary"
            >PREGUNTAS FRECUENTES</v-btn
          >
        </router-link>
        <p class="mt-3 body-2">Universidad Vizcaya de las Américas © 2023</p>
        <a href="mailto:informes@uvaenlinea.com" target="_blank">
          <p class="mt-3 body-2">informes@uvaenlinea.com</p>
        </a>
      </v-col>
    </v-footer>
    <v-dialog
      v-model="openPopup"
      max-width="700"
      style="z-index: 20000 !important"
    >
      <v-card class="mx-auto text-center">
        <div
          :class="[
            $vuetify.breakpoint.mdAndUp
              ? 'd-flex justify-end'
              : 'd-flex justify-center',
          ]"
        >
          <v-btn
            text
            style="position: absolute; z-index: 1"
            dark
            large
            icon
            @click="$store.dispatch('home/setModalImagen', false)"
          >
            <v-icon size="x-large">mdi mdi-close</v-icon>
          </v-btn>
        </div>
        <router-link :to="link_buenfin">
          <v-img :src="imagen"></v-img>
        </router-link>
      </v-card>
    </v-dialog>
  </v-app>
</template>
<style>
html,
body {
  overflow-x: hidden !important;
}
.bg-blue {
  background-color: #141c3e !important;
}
.floating-button {
  z-index: 1000 !important;
  cursor: pointer !important;
  position: fixed !important;
  height: 3.7rem !important;
  width: 3.7rem !important;
}
.uvaldo-btn {
  bottom: 20px;
  left: 20px;
}
.border-btn {
  border: 2px solid white;
}
.bg-flex {
  background-size: cover;
  height: 100vh;
  position: relative;
}
.w-100 {
  width: 100%;
}
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.word-break {
  word-break: break-word;
}
.p-1pcnt {
  padding: 1%;
}
</style>
<script>
import { mask } from "vue-the-mask";
import { mapState, mapGetters } from "vuex";
import axios from "axios";
export default {
  name: "App",
  directives: {
    mask,
  },
  mounted() {
    this.$store.dispatch("home/getFeedData");
  },
  data() {
    return {
      maest: [
        { name: "MAESTRÍA EN EDUCACIÓN", link: "/maestria-en-educacion" },
      ],
      dips: [
        { name: "GESTIÓN ESTRATÉGICA PERSONAL", link: "/estrategica-personal" },
        {
          name: "GESTIÓN LOGÍSTICA PARA EL COMERCIO EXTERIOR",
          link: "/gestion-logistica",
        },
        {
          name: "GESTIÓN ESTRATÉGICA DE CAPITAL HUMANO",
          link: "/gestion-capital-humano",
        },
        {
          name: "GESTIÓN DE EVALUACIÓN DEL APRENDIZAJE",
          link: "/evaluacion-del-aprendizaje",
        },
        {
          name: "SALUD PÚBLICA",
          link: "/salud-publica",
        },        
      ],
      direction: "top",
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",
      link_covid: "/covid19",
      link_diav: "/quejas-y-sugerencias",
      link_buenfin: "/modelo-educativo",
      publicPath: process.env.BASE_URL,
      offsetTop: 0,
      information: {
        email: "",
        password: "",
      },
      drawer: false,
      dialog: false,
      dominio: "viztepic",
      alwaysShow: false,
      snackbar: false,
      text: "",
    };
  },

  methods: {
    toAviso() {
      this.$router.push("/aviso_de_privacidad");
    },
    onScroll(e) {
      this.offsetTop = window.scrollY;
    },
    loginRedirect() {
      if (this.information.email == "" || this.information.email == null) {
        this.text = "Escribe un usuario";
        this.snackbar = true;
      } else if (
        this.information.password == "" ||
        this.information.password == null
      ) {
        this.text = "Ingresa la contraseña";
        this.snackbar = true;
      } else {
        this.snackbar = false;
        nativeForm.submit();
      }
    },
  },
  computed: {
    ...mapState({
      openPopup: (state) => state.home.openPopup,
      offer: (state) => state.home.offer,
      imagen: (state) => state.home.imagen,
      sliders: (state) => state.home.sliders,
    }),
    bgColor() {
      if (this.offsetTop > 100) {
        return "white";
      } else {
        return "transparent";
      }
    },
  },
  created() {
    window.addEventListener("scroll", this.onScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.onScroll);
  },
};
</script>
